import ListCurrentGeneController from "../components/list/ListCurrentGeneController";
import ListUrlStateController from "../components/list/ListUrlStateController";
import ListUserInterface from "../components/list/ListUserInterface";
import {ListProvider} from "../contexts/ListContext";
import {usePageTitle} from "../hooks/usePageTitle";

const List = () => {
  usePageTitle("List View");

  return <ListProvider>
    <ListUrlStateController/>
    <ListCurrentGeneController/>
    <ListUserInterface/>
  </ListProvider>
}

export default List;
